var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* istanbul ignore file */
import * as React from "react";
import { observable, computed, action } from "mobx";
import { observer } from "mobx-react";
import { CurrencyHelpers } from "../../../../helpers";
const intervalStep = 15;
const divideNumberForStepCount = 100;
let Counter = class Counter extends React.Component {
    constructor() {
        super(...arguments);
        this.increaseSum = 0;
    }
    componentDidMount() {
        this.interval(this.props.total, this.props.total / divideNumberForStepCount);
    }
    render() {
        return (React.createElement("div", { className: "rj-jackpot-winning-animation__total" },
            React.createElement("span", null, this.moneyFormat)));
    }
    get moneyFormat() {
        return CurrencyHelpers.moneyFormat("{1} {0}", this.increaseSum, this.props.currencyCode);
    }
    interval(total, stepCount) {
        const retry = () => setTimeout(this.interval, intervalStep, total, stepCount);
        if (this.increaseSum <= total) {
            this.increaseSum += stepCount;
            retry();
        }
        else {
            this.increaseSum = total;
        }
    }
};
__decorate([
    observable,
    __metadata("design:type", Number)
], Counter.prototype, "increaseSum", void 0);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], Counter.prototype, "moneyFormat", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number]),
    __metadata("design:returntype", void 0)
], Counter.prototype, "interval", null);
Counter = __decorate([
    observer
], Counter);
export { Counter };
//# sourceMappingURL=Counter.js.map